"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = bindSandbox;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _bindnode = _interopRequireDefault(require("./bindnode"));

var _unbindnode = _interopRequireDefault(require("./unbindnode"));

var _checkobjecttype = _interopRequireDefault(require("./_helpers/checkobjecttype"));

// binds or rebinds sandbox node
function bindSandbox(object, node, evt) {
  if ((0, _typeof2["default"])(this) === 'object' && this.isSeemple) {
    // when context is Seemple instance, use this as an object and shift other args

    /* eslint-disable no-param-reassign */
    evt = node;
    node = object;
    object = this;
    /* eslint-enable no-param-reassign */
  } else {
    // throw error when object type is wrong
    (0, _checkobjecttype["default"])(object, 'bindSandbox');
  }

  (0, _unbindnode["default"])(object, 'sandbox', null, evt);
  return (0, _bindnode["default"])(object, 'sandbox', node, null, evt);
}
//# sourceMappingURL=bindsandbox.js.map